import { useEffect, useState } from 'react';
import { AssemblyStatus, IMappedLocationGroupDaypart } from 'src/interfaces';
import { formatDate } from 'src/utils';
import { formatTimestamp } from 'src/utils/date';

// Sort by status to improve UX
export const statusOrder = {
  [AssemblyStatus.SCHEDULED]: 0,
  [AssemblyStatus.LIVE]: 1,
  [AssemblyStatus.EXPIRED]: 2,
};

export const useLocationScheduleTable = (
  tableData: IMappedLocationGroupDaypart[],
  isSortModified: boolean,
) => {
  const [formattedData, setFormattedData] = useState<
    IMappedLocationGroupDaypart[]
  >([]);

  useEffect(() => {
    if (tableData.length === 0) {
      setFormattedData([]);

      return;
    }

    // Format the dates with computed statuses
    let formatted = tableData.map((item) => ({
      ...item,
      startDate: formatDate(item.startDate),
      endDate: formatDate(item.endDate),
      assemblyScheduleDate:
        formatTimestamp(item?.assemblyScheduleDate || '') || '',
      status: item.status || AssemblyStatus.EXPIRED,
    }));

    // Only sort by status when no other table sorting is active
    if (!isSortModified) {
      formatted = formatted.sort(
        (a, b) => statusOrder[a.status] - statusOrder[b.status],
      );
    }

    setFormattedData(formatted);
  }, [tableData, isSortModified]);

  return {
    sortTableData: formattedData,
  };
};
